import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { STORAGE_KEYS } from '../config/constants';

const AuthContext = createContext(null);

const MOCK_USERS = [
  {
    id: 'user_001',
    name: 'Alex Rivera',
    email: 'alex@luminary.io',
    password: 'password123',
    username: 'alexrivera',
    bio: 'Design systems architect & creative technologist. Building at the intersection of code and craft.',
    avatar: 'https://i.pravatar.cc/150?img=11',
    role: 'admin',
    followers: 4821,
    following: 312,
    posts: 94,
    joinedDate: '2022-03-15',
    location: 'San Francisco, CA',
    website: 'https://alexrivera.io',
  },
];

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
    const storedUser = localStorage.getItem(STORAGE_KEYS.USER);
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = useCallback(async (email, password) => {
    const found = MOCK_USERS.find(
      (u) => u.email === email && u.password === password
    );
    if (!found) throw new Error('Invalid email or password.');
    const { password: _pw, ...safeUser } = found;
    const mockToken = `mock_token_${Date.now()}`;
    setUser(safeUser);
    setToken(mockToken);
    localStorage.setItem(STORAGE_KEYS.AUTH_TOKEN, mockToken);
    localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(safeUser));
    return safeUser;
  }, []);

  const logout = useCallback(() => {
    setUser(null);
    setToken(null);
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.USER);
  }, []);

  const updateUser = useCallback((updates) => {
    setUser((prev) => {
      const updated = { ...prev, ...updates };
      localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify(updated));
      return updated;
    });
  }, []);

  const value = {
    user,
    token,
    loading,
    isAuthenticated: !!token,
    login,
    logout,
    updateUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};

export default AuthContext;
